
import {initWebComponent} from "@/helpers/web-component-helper";

const template = document.createElement('template');
template.innerHTML = `<header-button data-icon="fa fa-cloud" data-tooltip="openDataPortal"></header-button>`;

export class HeaderDataPortalComponent extends HTMLElement {
    constructor(){
        super();
        initWebComponent(this, template)

        this.addEventListener('click', () => {
            window.open(window.kaartViewerUrl + '/portaal/index.html?website=' + window.websiteName, 'dataportaal')
        });
    }
}
